export default [
  {
    path: '/programmes',
    name: 'programmes',
    component: () => import('@/components/Layouts/Public.vue'),
    meta: {
      title: 'Our Programmes',
      sort: 3,
      withSubmenu: true,
      external: true,
      excludeFromRoot: true,
      authenticatable: false,
      icon: 'mdi-book-multiple-variant',
    },
    children: [
      {
        path: 'cybersecurity-law-and-cyber-terrorism',
        name: 'programmes.law',
        component: () => import('../Law.vue'),
        meta: {
          title: 'Cybersecurity Law & Cyber Terrorism',
          sort: 3,
          external: true,
          excludeFromRoot: true,
          authenticatable: false,
          icon: 'mdi-security-account-outline',
        },
      },
      {
        path: 'cybersecurity-act-2018-compliance',
        name: 'programmes.act',
        component: () => import('../Act.vue'),
        meta: {
          title: 'Cybersecurity Act 2018 Compliance',
          sort: 3,
          external: true,
          excludeFromRoot: true,
          authenticatable: false,
          icon: 'mdi-clipboard-check-outline',
        },
      },
      {
        path: 'cybersecurity-governance-risk-and-compliance',
        name: 'programmes.governance',
        component: () => import('../Governance.vue'),
        meta: {
          title: 'Cybersecurity Governance, Risk & Compliance',
          sort: 3,
          external: true,
          excludeFromRoot: true,
          authenticatable: false,
          icon: 'mdi-alert-outline',
        },
      },
      {
        path: 'strategic-cybersecurity-risk-management',
        name: 'programmes.strategic',
        component: () => import('../Strategic.vue'),
        meta: {
          title: 'Strategic Cybersecurity Risk Management',
          sort: 3,
          external: true,
          excludeFromRoot: true,
          authenticatable: false,
          icon: 'mdi-bell-ring-outline',
        },
      },
      {
        path: 'cybersecurity-performance-management',
        name: 'programmes.performance',
        component: () => import('../Performance.vue'),
        meta: {
          title: 'Cybersecurity Performance Management',
          sort: 3,
          external: true,
          excludeFromRoot: true,
          authenticatable: false,
          icon: 'mdi-finance',
        },
      },
    ]
  },
]
